export const ERRORS = {
  // Tenant
  // AssistBnBに存在している会社名がバレてしまうが、UXを優先してこのエラーメッセージにする.
  TENANT_ALREADY_EXISTS: '既に登録されている会社名です。',
  // Authentication.
  AUTH_EMAIL_NOT_SENT: 'メール送信に失敗しました',
  AUTH_USER_NOT_CREATED: 'ユーザ作成に失敗しました。',
  AUTH_SOMETHING_WENT_WRONG: 'Something went wrong while trying to authenticate.',
  // Invite
  INVITE_ALREADY_EXISTS: '*既に招待されているメールアドレスです。',
  INVITE_SOMETHING_WENT_WRONG:
    '招待処理中にエラーが発生しました。しばらくしてからもう一度お試しください。',
  INVITE_NOT_FOUND: '招待が見つからないか、操作の権限がありません。',
  OWNER_OR_LISTING_NOT_FOUND:
    'オーナーまたはリスティングが見つからないか、操作の権限がありません。',
  // Onboarding
  ONBOARDING_USERNAME_ALREADY_EXISTS: '既に登録済みのユーザ名です',
  ONBOARDING_SOMETHING_WENT_WRONG: 'Something went wrong while trying to onboard.',
  // Stripe
  STRIPE_MISSING_SIGNATURE: 'Unable to verify webhook signature.',
  STRIPE_MISSING_ENDPOINT_SECRET: 'Unable to verify webhook endpoint.',
  STRIPE_CUSTOMER_NOT_CREATED: 'Unable to create customer.',
  STRIPE_SOMETHING_WENT_WRONG: 'Something went wrong while trying to handle Stripe API.',
  // Misc
  UNKNOWN: 'Unknown error.',
  ENVS_NOT_INITIALIZED: 'Environment variables not initialized.',
  SOMETHING_WENT_WRONG: 'Something went wrong.',
  // Reservation
  RESERVATION_NOT_UPDATED: '予約情報の更新に失敗しました。',
  // Listing
  LISTING_LIMIT_EXCEEDED: 'リスティング数の上限に達しました。',
  LISTING_AIRBNB_ID_ALREADY_EXISTS:
    'この Airbnb リスティング ID は既に他のリスティングで使用されています。',
  // Slack
  SLACK_SOMETHING_WENT_WRONG: 'Slack送信でエラーが発生しました。',

  // =======================
  // 清掃管理
  // =======================
  OWNER_EMAIL_ALREADY_EXISTS: '既に登録されているメールアドレスです。'
} as const

// 清掃予定の重複エラーの code.
// クライアント側でも参照するためここに置く (ERROR_MESSAGES は .server モジュールを
// import しているためクライアントから import できない).
export const CLEAN_SCHEDULE_OVERLAP_ERROR_CODE = 'CLEAN_SCHEDULE_OVERLAP'
